import { apiRequest } from './client'
import type { ApiBanner, BannerPlacement } from './types'

export function listBanners(
  activeOnly = true,
  placement?: BannerPlacement,
): Promise<ApiBanner[]> {
  return apiRequest<ApiBanner[]>('/banners', {
    query: { activeOnly, placement },
  })
}
